module.exports = __webpack_public_path__ + "img/decoration-ground.2cb91483.svg";